import * as Sentry from "@sentry/nextjs"
import { AtlasLinkConstructor, CampusHeader, CampusThemeContext } from 'atlas-ds'
import Link from "next/link"
import { useRouter } from "next/router"
import { EntrepriseContext } from "pages/_app"
import { useContext, useEffect, useRef } from "react"
import { useAPIProfil } from "services/auth"
import { BRANCHE_CAP, CAP_COMPETENCE_URL } from "services/global"
import { Entreprise } from "services/model"
import CompaniesList from "./companies-list"
import { useOidcSession } from "services/useOidcSession"

interface HeaderProps {
    entreprise: Entreprise
    selectEntreprise: (entreprise: Entreprise) => void
}

export default function Header(props: HeaderProps) {
    const [entreprise, setEntreprise] = useContext(EntrepriseContext)
    const { data: session, status } = useOidcSession()
    const isUser = !!session?.user
    const router = useRouter()

    const { data: profil } = useAPIProfil()
    const entreprises = profil?.entreprises

    const theme = useContext(CampusThemeContext);

    const defineEntreprise = (entreprise: Entreprise | null) => {
        setEntreprise(entreprise);
        Sentry.setContext("entreprise", {
            name: entreprise?.name,
            siret: entreprise?.siret,
            branche: entreprise?.branche?.valueName,
        })
    }

    useEffect(() => {
        if (!router.isReady) return

        if (!isUser && !session && status === "unauthenticated") {
            localStorage.removeItem("currentCompany")
            defineEntreprise(null)
            return
        }

        const currEnt = localStorage.getItem("currentCompany") ?? null
        const ent = currEnt ? JSON.parse(currEnt) : null

        console.log("isUser: " + isUser + ", session: " + session + ", entreprise: " + router.query.entreprise)

        let found = false
        const routerEntreprise = router.query.entreprise
        let entrepriseCourante = entreprise
        if (isUser && session && routerEntreprise) {
                if (ent && routerEntreprise === ent.siret) {
                    console.log("Entreprise trouvée")
                    found = true;
                } else if (entreprises) {
                    console.log("Recherche entreprise dans la liste")
                    const e = entreprises.find((e) => e.siret === routerEntreprise);
                    if (e) {
                        localStorage.setItem("currentCompany", JSON.stringify(e))
                        defineEntreprise(e)
                        entrepriseCourante = e
                        found = true
                    }
                } else if (!entreprises) {
                    console.log("Liste non chargée")
                    return  // Retarde la sélection de l'entreprise tant que les entreprises ne sont pas chargées
                }
        }
 
        if (found) {
            console.log("Redirect vers theme")
            router.replace(entrepriseCourante?.branche?.valueName === BRANCHE_CAP ? CAP_COMPETENCE_URL : "/")
        } else {
            const currEnt = localStorage.getItem("currentCompany") ?? null
            if (currEnt) {
                console.log("Entreprise du localStorage")
                const ent = JSON.parse(currEnt);
                if (
                    isUser &&
                    session &&
                    entreprises &&
                    entreprises.length > 0 &&
                    !entreprises.find((e) => e.id === ent.id)
                ) {
                    const e = entreprises[0];
                    localStorage.setItem("currentCompany", JSON.stringify(e));
                    defineEntreprise(e);
                } else {
                    defineEntreprise(ent);
                }
            } else if (
                isUser &&
                session &&
                session.accessToken &&
                entreprises &&
                entreprises.length > 0
            ) {
                const e = entreprises[0];
                localStorage.setItem("currentCompany", JSON.stringify(e))
                defineEntreprise(e)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.isReady, isUser, entreprises])

  const detailsRef = useRef<HTMLDetailsElement>(null)

  function closeDetails() {
      if (detailsRef.current) detailsRef.current.open = false
  }

  const selectCompany = (entreprise: Entreprise) => {
      props.selectEntreprise(entreprise)
      closeDetails()
  }

  const linkConstructor: AtlasLinkConstructor = (
      props: any,
      content: React.ReactNode
  ): JSX.Element => (
      (<Link
        {...props}
        aria-current={router.route === "/" ? "page" : undefined}
        href={theme === "cap" ? CAP_COMPETENCE_URL : '/'}
      >
        {content}
      </Link>)
  )

  return <CampusHeader
      ref={detailsRef}
      linkConstructor={linkConstructor}
      currentCompany={profil ? entreprise?.name : undefined}
      companiesList={
          entreprises && entreprises.length > 1 ? (
              <CompaniesList onSelect={ selectCompany } entreprises={ entreprises } />
          ) : undefined
      }
  />
}
